import { Dispatch, SetStateAction } from "react";
import { useLocalStorage } from "usehooks-ts";

export function useAdminContentVisible(): [
  boolean,
  Dispatch<SetStateAction<boolean>>
] {
  return useLocalStorage<boolean>("AdminContentVisible", true);
}
